import React from 'react';
import {Carousel} from 'react-bootstrap'
import {Button} from "react-bootstrap"
import _ from 'lodash'
import { userApi } from "../../../api"; /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
import  '../../Styles/css/home.css';

export default props => {
	const { banners } = props

	/*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/
    async function learnMoreClick(slug){
        let page="Home";
       //slug = "faq";
        let obj={};
        obj['userid']=localStorage['currentuserid'];
        obj['message']= page +'-'+ slug ;
    await userApi.setUserActivitylog(obj); 
	//window.location.href = "/"+ slug;
	window.location.href = slug;
    }
    /*Comments: User Activity Log Code Changes, Added By: <Asar>, Create Date: <2020-01-21>*/

	const bannerItems = banners.map( (banner,index) => {
			const bannerUrl = _.find(banner.node.featuredImage.mediaDetails.sizes, ['name', 'header-image']) || ""
			return (
				<Carousel.Item key={index}>
				<img
					className="d-block w-100 home-banner-img"
					src={bannerUrl.sourceUrl}
					alt="First slide"
				/>
				<Carousel.Caption>
				<h3>{banner.node.title}</h3>
				<div dangerouslySetInnerHTML={{ __html: banner.node.content }}></div>
				{
					//banner.node.banner_link && <Button href={banner.node.banner_link}>Learn More</Button>  {/*Comments: User Activity Log Code Changes, Modified By: <Asar>, Date Modified: <2020-01-21>*/}
					banner.node.banner_link && <Button onClick={()=>learnMoreClick(banner.node.banner_link)}>Learn More</Button>  /*Comments: User Activity Log Code Changes, Modified By: <Asar>, Date Modified: <2020-01-21>*/

				}
				</Carousel.Caption>			
				</Carousel.Item>
			)
	})
	
	return(
		<Carousel className="home-banner">
			{
				!bannerItems.length &&
				<div className="text-center p-5">
				<div className="spinner-border text-secondary" role="status">
					<span className="sr-only">Loading...</span>
				</div>
				</div>
			}
			{!!bannerItems.length && bannerItems}
		</Carousel>
	)
}